import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const DismissButtonStyle = css`
  width: 209px;
  height: 48px;
  border-color: #999999;
  color: #999999;
  :hover {
    background-color: rgba(153, 153, 153, 0.2);
  }
  :active {
    background: #999999;
  }
`;

export const LicenseInfoDetail = styled.div`
  color: #777777;
`;
export const FilterStyle = css`
  display: inline-flex;
  margin: 0;
  height: 70px;
  justify-content: flex-start;
`;
